import { cardStringParser } from '../../../types/cardTypes';
import { currencyIndexParser, turnStateOrdinalParser } from '../../../types/pokerTypes';
import { pokerVariantIndexParser } from '../../../types/pokerVariantTypes';
import { playerAvatarParser } from '../commonInbounds/utils/playerAvatarInboundUtils';
import { inboundPlayerServerSettingsParser } from '../commonInbounds/utils/playerServerSettingsInboundUtils';
import { booleanParser, createArrayWithBracesParser, encodedStringParser, numberArrayParser, numberParser, stringParser } from '../inboundParsers';
import { splitWithBraces, trimBraces } from '../inboundUtils';
import { inboundPokerPlayerParser, optionalSeatIndexParser, seatIndexesParser } from './utils/pokerInboundUtils';
import { themeSetParser } from './utils/themeInboundUtils';
function inboundBlindTimerParser(str) {
    const [roundSecondsTotal, roundSecondsRemaining] = trimBraces(str).split(',').map(Number);
    return { roundSecondsTotal, roundSecondsRemaining };
}
export const INIT_POKER_ROOM_INBOUND_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'buyIn', parser: numberParser },
        { name: 'hasBuyInRange', parser: booleanParser },
        { name: 'minBuyIn', parser: numberParser },
        { name: 'maxBuyIn', parser: numberParser },
        { name: 'smallBlind', parser: numberParser },
        { name: 'bigBlind', parser: numberParser },
        { name: 'isAprilFoolsDay', parser: booleanParser },
        { name: 'inboundPokerPlayers', parser: createArrayWithBracesParser(inboundPokerPlayerParser) },
        { name: 'salePercentMore', parser: numberParser },
        { name: 'currency', parser: currencyIndexParser },
        { name: 'roomName', parser: encodedStringParser },
        { name: 'roomId', parser: numberParser },
        { name: 'turnState', parser: turnStateOrdinalParser },
        { name: 'statusMessage', parser: encodedStringParser },
        { name: 'communityCards', parser: communityCardsStringParser },
        { name: 'actionSeatIndex', parser: optionalSeatIndexParser },
        { name: 'buttonSeatIndex', parser: optionalSeatIndexParser },
        { name: 'potAmounts', parser: numberArrayParser },
        { name: 'numMttTables', parser: numberParser },
        { name: 'dealerNum', parser: numberParser },
        { name: 'seatIndexesAvailable', parser: seatIndexesParser },
        { name: 'isTourneyTable', parser: booleanParser },
        { name: 'isMtt', parser: booleanParser },
        { name: 'isDualLimit', parser: booleanParser },
        { name: 'isTourneyOwner', parser: booleanParser },
        { name: 'isLevelTourney', parser: booleanParser },
        { name: 'levelTourneyChallengerId', parser: numberParser },
        { name: 'levelTourneyChallengerName', parser: stringParser },
        { name: 'levelTourneyLevel', parser: numberParser },
        { name: 'numJacksSponsored', parser: numberParser },
        { name: 'jacksSponsorName', parser: stringParser },
        { name: 'hasTourneyStarted', parser: booleanParser },
        { name: 'timerDelayMs', parser: numberParser },
        { name: 'timerDelayTotalMs', parser: numberParser },
        { name: 'delayIndex', parser: numberParser }, // TODO: does this affect anything in the UI, or affect client side timings?
        { name: 'sideBetAmount', parser: numberParser },
        { name: 'numSideBets', parser: numberParser },
        { name: 'numHandsPlayedInRoom', parser: numberParser },
        { name: 'handThemeOffset', parser: numberParser },
        { name: 'betRoundNumber', parser: numberParser }, // TODO: use a string type, such as 'flop', 'turn' etc?
        { name: 'betSequenceNumber', parser: numberParser },
        { name: 'sessionId', parser: stringParser },
        { name: 'reconnectSeatIndex', parser: optionalSeatIndexParser },
        { name: 'isSittingOut', parser: booleanParser },
        { name: 'avatar', parser: playerAvatarParser },
        { name: 'inboundPlayerServerSettings', parser: inboundPlayerServerSettingsParser },
        { name: 'playerLevel', parser: numberParser },
        { name: 'willRevealThisHand', parser: booleanParser },
        { name: 'isNinjaAdmin', parser: booleanParser },
        { name: 'isNinjaOn', parser: booleanParser },
        { name: 'pokerVariant', parser: pokerVariantIndexParser },
        { name: 'inboundBlindTimer', parser: inboundBlindTimerParser },
        { name: 'powerPlayerPrefixHtml', parser: encodedStringParser },
        { name: 'isFpsCounterEnabled', parser: booleanParser },
        { name: 'themeSet', parser: themeSetParser },
        { name: 'isMixedGame', parser: booleanParser },
        { name: 'isAllInGame', parser: booleanParser },
        { name: 'isAggroBettingFilterEnabled', parser: booleanParser }
    ]
};
function communityCardsStringParser(str) {
    const communityCardsStrings = splitWithBraces(trimBraces(str));
    if (!communityCardsStrings[0].length) {
        return [];
    }
    return communityCardsStrings.map((communityCardString, index) => {
        return {
            index,
            card: cardStringParser(communityCardString),
            cardEmphasis: 'normal'
        };
    });
}
